/* Wellness Territory - cart upsell slider + add-to-cart. Loaded once on page load so the
   delegated listeners survive AJAX cart-drawer re-renders (inline scripts injected via
   innerHTML never execute, which is why the arrows used to be dead).
   Shares the window.wtCuBound flag with the snippet's inline copy so only one binds:
   on a server-rendered cart the inline runs first and this no-ops; on an empty->add
   cart the inline never executes and this one binds. Either way: exactly one handler. */
(function () {
  if (window.wtCuBound) return;
  window.wtCuBound = true;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function trackOf(el) {
    var w = el.closest('.wt-cu');
    return w ? w.querySelector('.wt-cu__track') : null;
  }

  function go(track, dir) {
    if (!track) return;
    var n = track.children.length;
    if (n <= 1) return;
    var idx = parseInt(track.getAttribute('data-idx') || '0', 10);
    idx = Math.max(0, Math.min(n - 1, idx + dir));
    track.setAttribute('data-idx', idx);
    track.style.transform = 'translateX(-' + (idx * 100) + '%)';
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var nb = e.target.closest('.wt-cu__navbtn');
    if (nb) {
      e.preventDefault();
      go(trackOf(nb), nb.classList.contains('wt-cu__nav--next') ? 1 : -1);
      return;
    }

    var btn = e.target.closest('.wt-cu__add');
    if (!btn || btn.disabled) return;
    var card = btn.closest('.wt-cu__card');
    var sel = card ? card.querySelector('.wt-cu__select') : null;
    var vid = sel ? sel.value : btn.getAttribute('data-vid');
    if (!vid) return;
    e.preventDefault();
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding';
    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (j) { throw j; }); }
        return r.json();
      })
      .then(function () {
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
  });

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    var sel = e.target.closest('.wt-cu__select');
    if (!sel) return;
    var card = sel.closest('.wt-cu__card');
    if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    var pe = card.querySelector('.wt-cu__price');
    if (pe && opt.getAttribute('data-price')) pe.textContent = opt.getAttribute('data-price');
    var ce = card.querySelector('.wt-cu__compare');
    if (ce) {
      var c = opt.getAttribute('data-compare');
      if (c) { ce.textContent = c; ce.style.display = ''; } else { ce.style.display = 'none'; }
    }
    var ab = card.querySelector('.wt-cu__add');
    if (ab) ab.setAttribute('data-vid', sel.value);
  });
})();
